import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import FormLabel from "../styledElements/label";
import InputError from "../styledElements/inputError";
import StyledTimePicker from "../styledElements/styledTimePicker";
class TimePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTime: moment()
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({
                selectedTime: moment.isMoment(this.props.value)
                    ? this.props.value
                    : moment(this.props.value, this.props.timeFormat)
            });
        }
    }

    handleChange(time) {
        this.setState({
            selectedTime: time
        });
        return this.props.onChange({
            name: this.props.name,
            value: time.format(this.props.timeFormat)
        });
    }

    render() {
        const { label, name, value, onChange, error, ...rest } = this.props;

        return (
            <div>
                {label && (
                    <FormLabel name={name} label={label} {...this.props}>
                        {label}
                    </FormLabel>
                )}

                {this.props.easyRead && <b>{this.props.easyRead}</b>}

                <StyledTimePicker
                    name={this.props.name}
                    defaultValue={this.state.selectedTime}
                    value={this.state.selectedTime}
                    onChange={this.handleChange.bind(this)}
                    {...rest}
                />

                <InputError error={error} />
            </div>
        );
    }
}

TimePicker.displayName = "TimePicker";

TimePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    showSecond: PropTypes.bool,
    use12Hours: PropTypes.bool,
    error: PropTypes.string,
    timeFormat: PropTypes.string
};

TimePicker.defaultProps = {
    showSecond: false,
    error: "",
    timeFormat: "HH:mm"
};

export default TimePicker;
